import { Injectable } from '@angular/core';
import { NzTreeNode } from 'ng-zorro-antd/core/tree';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { AlainConfigService, AlainUtilArrayConfig } from '../config';

export interface ArrayServiceTreeToArrOptions {
  /** æ·±åº¦é¡¹åï¼é»è®¤ï¼`'deep'` */
  deepMapName?: string;
  /** æå¹³åæ°ç»çç¶æ°æ®é¡¹åï¼é»è®¤ï¼`'parent'` */
  parentMapName?: string;
  /** æºæ°æ®å­é¡¹åï¼é»è®¤ï¼`'children'` */
  childrenMapName?: string;
  /** æ¯å¦ç§»é¤ `children` èç¹ï¼é»è®¤ï¼`true` */
  clearChildren?: boolean;
  /** è½¬æ¢ææ°ç»ç»ææ¶åè° */
  cb?: (item: NzSafeAny, parent: NzSafeAny, deep: number) => void;
}

export interface ArrayServiceArrToTreeOptions {
  /** ç¼å·é¡¹åï¼é»è®¤ï¼`'id'` */
  idMapName?: string;
  /** ç¶ç¼å·é¡¹åï¼é»è®¤ï¼`'parent_id'` */
  parentIdMapName?: string;
  /** å­é¡¹åï¼é»è®¤ï¼`'children'` */
  childrenMapName?: string;
  /** è½¬æ¢ææ æ°æ®æ¶åè° */
  cb?: (item: NzSafeAny) => void;
}

export interface ArrayServiceArrToTreeNodeOptions {
  /** ç¼å·é¡¹åï¼é»è®¤ï¼`'id'` */
  idMapName?: string;
  /** ç¶ç¼å·é¡¹åï¼é»è®¤ï¼`'parent_id'` */
  parentIdMapName?: string;
  /** æ é¢é¡¹åï¼é»è®¤ï¼`'title'` */
  titleMapName?: string;
  /** è®¾ç½®ä¸ºå¶å­èç¹é¡¹åï¼è¥æ°æ®æºä¸å­å¨æ¶èªå¨æ ¹æ® `children` å¼å³å®æ¯å¦ä¸ºå¶å­èç¹ï¼é»è®¤ï¼`'isLeaf'` */
  isLeafMapName?: string;
  /** èç¹ Checkbox æ¯å¦éä¸­é¡¹åï¼é»è®¤ï¼`'checked'` */
  checkedMapname?: string;
  /** èç¹æ¬èº«æ¯å¦éä¸­é¡¹åï¼é»è®¤ï¼`'selected'` */
  selectedMapname?: string;
  /** èç¹æ¯å¦å±å¼(å¶å­èç¹æ æ)é¡¹åï¼é»è®¤ï¼`'expanded'` */
  expandedMapname?: string;
  /** è®¾ç½®æ¯å¦ç¦ç¨èç¹(ä¸å¯è¿è¡ä»»ä½æä½)é¡¹åï¼é»è®¤ï¼`'disabled'` */
  disabledMapname?: string;
  /** è½¬æ¢ææ æ°æ®åï¼æ§è¡çéå½åè° */
  cb?: (item: NzSafeAny, parent: NzSafeAny, deep: number) => void;
}

export interface ArrayServiceGetKeysByTreeNodeOptions {
  /** æ¯å¦åå«åéç¶æçå¼ï¼é»è®¤ï¼`true` */
  includeHalfChecked?: boolean;
  /** æ¯å¦éæ°æå® `key` é®åï¼è¥ä¸æå®è¡¨ç¤ºä½¿ç¨ `NzTreeNode.key` å¼ */
  keyMapName?: string;
  /** åè°ï¼è¿åä¸ä¸ªå¼ `key` å¼ï¼ä¼åçº§é«äºå¶ä» */
  cb?: (item: NzTreeNode, parent: NzTreeNode, deep: number) => NzSafeAny;
}

@Injectable({ providedIn: 'root' })
export class ArrayService {
  private c: AlainUtilArrayConfig;
  constructor(cog: AlainConfigService) {
    this.c = cog.merge<AlainUtilArrayConfig, 'utilArray'>('utilArray', {
      deepMapName: 'deep',
      parentMapName: 'parent',
      idMapName: 'id',
      parentIdMapName: 'parent_id',
      childrenMapName: 'children',
      titleMapName: 'title',
      checkedMapname: 'checked',
      selectedMapname: 'selected',
      expandedMapname: 'expanded',
      disabledMapname: 'disabled',
    });
  }
  /**
   * å°æ ç»æè½¬æ¢ææ°ç»ç»æ
   */
  treeToArr(tree: NzSafeAny[], options?: ArrayServiceTreeToArrOptions): NzSafeAny[] {
    const opt = {
      deepMapName: this.c.deepMapName,
      parentMapName: this.c.parentMapName,
      childrenMapName: this.c.childrenMapName,
      clearChildren: true,
      cb: null,
      ...options,
    } as ArrayServiceTreeToArrOptions;
    const result: NzSafeAny[] = [];
    const inFn = (list: NzSafeAny[], parent: NzSafeAny, deep: number = 0) => {
      for (const i of list) {
        i[opt.deepMapName!] = deep;
        i[opt.parentMapName!] = parent;
        if (opt.cb) {
          opt.cb(i, parent, deep);
        }
        result.push(i);
        const children = i[opt.childrenMapName!];
        if (children != null && Array.isArray(children) && children.length > 0) {
          inFn(children, i, deep + 1);
        }
        if (opt.clearChildren) {
          delete i[opt.childrenMapName!];
        }
      }
    };
    inFn(tree, 1);
    return result;
  }

  /**
   * æ°ç»è½¬æ¢ææ æ°æ®
   */
  arrToTree(arr: NzSafeAny[], options?: ArrayServiceArrToTreeOptions): NzSafeAny[] {
    const opt = {
      idMapName: this.c.idMapName,
      parentIdMapName: this.c.parentIdMapName,
      childrenMapName: this.c.childrenMapName,
      cb: null,
      ...options,
    } as ArrayServiceArrToTreeOptions;
    const tree: NzSafeAny[] = [];
    const childrenOf: NzSafeAny = {};
    for (const item of arr) {
      const id = item[opt.idMapName!];
      const pid = item[opt.parentIdMapName!];
      childrenOf[id] = childrenOf[id] || [];
      item[opt.childrenMapName!] = childrenOf[id];
      if (opt.cb) {
        opt.cb(item);
      }
      if (pid) {
        childrenOf[pid] = childrenOf[pid] || [];
        childrenOf[pid].push(item);
      } else {
        tree.push(item);
      }
    }
    return tree;
  }

  /**
   * æ°ç»è½¬æ¢æ `nz-tree` æ°æ®æºï¼éè¿ `options` è½¬åé¡¹åï¼ä¹å¯ä»¥ä½¿ç¨ `options.cb` æ´é«çº§å³å®æ°æ®é¡¹
   */
  arrToTreeNode(arr: NzSafeAny[], options?: ArrayServiceArrToTreeNodeOptions): NzTreeNode[] {
    const opt = {
      idMapName: this.c.idMapName,
      parentIdMapName: this.c.parentIdMapName,
      titleMapName: this.c.titleMapName,
      isLeafMapName: 'isLeaf',
      checkedMapname: this.c.checkedMapname,
      selectedMapname: this.c.selectedMapname,
      expandedMapname: this.c.expandedMapname,
      disabledMapname: this.c.disabledMapname,
      cb: null,
      ...options,
    } as ArrayServiceArrToTreeNodeOptions;
    const tree = this.arrToTree(arr, {
      idMapName: opt.idMapName,
      parentIdMapName: opt.parentIdMapName,
      childrenMapName: 'children',
    });
    this.visitTree(tree, (item: NzSafeAny, parent: NzSafeAny, deep: number) => {
      item.key = item[opt.idMapName!];
      item.title = item[opt.titleMapName!];
      item.checked = item[opt.checkedMapname!];
      item.selected = item[opt.selectedMapname!];
      item.expanded = item[opt.expandedMapname!];
      item.disabled = item[opt.disabledMapname!];
      if (item[opt.isLeafMapName!] == null) {
        item.isLeaf = item.children.length === 0;
      } else {
        item.isLeaf = item[opt.isLeafMapName!];
      }
      if (opt.cb) {
        opt.cb(item, parent, deep);
      }
    });
    return tree.map(node => new NzTreeNode(node));
  }

  /**
   * éå½è®¿é®æ´ä¸ªæ 
   */
  visitTree(
    tree: NzSafeAny[],
    cb: (item: NzSafeAny, parent: NzSafeAny, deep: number) => void,
    options?: {
      /** å­é¡¹åï¼é»è®¤ï¼`'children'` */
      childrenMapName?: string;
    },
  ): void {
    options = {
      childrenMapName: this.c.childrenMapName,
      ...options,
    };
    const inFn = (data: NzSafeAny[], parent: NzSafeAny, deep: number) => {
      for (const item of data) {
        cb(item, parent, deep);
        const childrenVal = item[options!.childrenMapName!];
        if (childrenVal && childrenVal.length > 0) {
          inFn(childrenVal, item, deep + 1);
        }
      }
    };
    inFn(tree, null, 1);
  }

  /**
   * è·åææå·²ç»éä¸­ç `key` å¼
   */
  getKeysByTreeNode(tree: NzTreeNode[], options?: ArrayServiceGetKeysByTreeNodeOptions): NzSafeAny[] {
    const opt = {
      includeHalfChecked: true,
      ...options,
    } as ArrayServiceGetKeysByTreeNodeOptions;
    const keys: NzSafeAny[] = [];
    this.visitTree(tree, (item: NzTreeNode, parent: NzTreeNode, deep: number) => {
      if (item.isChecked || (opt.includeHalfChecked && item.isHalfChecked)) {
        keys.push(opt.cb ? opt.cb(item, parent, deep) : opt.keyMapName ? item.origin[opt.keyMapName] : item.key);
      }
    });
    return keys;
  }
}
